module.exports = __webpack_public_path__ + "img/fax.aca9ca00.svg";